/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElEmpty as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import { ElFormItem as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import __unplugin_components_6 from '~icons/ep/upload';
import { ElIcon as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_4 from '~icons/ep/document';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElCheckbox as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e216ecf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cascader-box"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, " 登录方式 ", -1));
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = {
  class: "header flex items-center justify-between"
};
const _hoisted_9 = {
  class: "flex items-center"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "参数配置", -1));
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = {
  key: 0,
  class: "operate-desc"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = {
  class: "form-item-col"
};
const _hoisted_16 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "marginL10"
}, "上传p8文件，用于生成appSecret", -1));
const _hoisted_18 = {
  key: 0,
  id: "input-file",
  class: "input-file",
  type: "file"
};
import UseLoginPay from '../loginPayHooks';
import UseConfig from '../configHook';
import { UseGlobalConfig } from '@/utils/hooks';
import { apiUsdkCheckParams, apiUsdkGetProductId, apiUsdkSaveInternalLoginSwitchConf } from '@/api/usdk';
import questionIcon from '@/assets/svg/question.svg';
export default /*#__PURE__*/_defineComponent({
  __name: 'internalLogin',
  props: {
    gid: {
      type: [Number, String],
      required: true
    },
    channel: {
      type: Object,
      default: () => ({})
    },
    loginParams: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['ok'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      createCnames
    } = UseLoginPay();
    const {
      $channel
    } = UseGlobalConfig();
    const {
      internalLogin,
      internalLoginParamsChannel,
      loginIcon
    } = UseConfig();
    const props = __props;
    const proParams = ref({});
    const showInputFile = ref(true);
    const productId = ref();
    const getProductId = () => {
      apiUsdkGetProductId({
        gid: props.gid,
        cid: props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          productId.value = res.data.productId;
        }
      });
    };
    watch(() => props.channel.cid, val => {
      if (val) {
        getProductId();
      }
    }, {
      immediate: true
    });
    watch(() => props.loginParams, _params => {
      if (_params) {
        let params = JSON.parse(JSON.stringify(_params));
        for (let key in params) {
          if (internalLoginParamsChannel.includes(key) && !params[key + 'Conf']) {
            params[key + 'Conf'] = {
              appId: '',
              appKey: '',
              platform: props.channel.channel === $channel.OFFICIAL_CHANNEL ? 'AND' : 'IOS',
              appSecret: '',
              universalLink: ''
            };
          }
        }
        proParams.value = JSON.parse(JSON.stringify(params));
        console.log('proParams.value', proParams.value);
      }
    }, {
      immediate: true,
      deep: true
    });
    const confirmLoading = ref(false);
    const emits = __emit;
    const form = ref();
    const handleSubmit = async () => {
      var _form$value;
      (_form$value = form.value) === null || _form$value === void 0 ? void 0 : _form$value.validate(async valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(proParams.value));
          let packCnames = '';
          let productCnames = '';
          await apiUsdkCheckParams({
            gid: props.gid,
            cid: props.channel.cid,
            type: 0
          }).then(res => {
            if (res.code === 0) {
              packCnames = createCnames(res.data.package);
              productCnames = createCnames(res.data.productId);
            }
          });
          ElMessageBox.confirm(`你正在编辑修改${props.channel.name}渠道登录开关/参数，修改后将直接立即影响线上游戏登录方式，请务必确认操作无误后再保存，否则因此导致的线上游戏登录事故后果自负!,
                                ${packCnames ? `同时我们检测到${packCnames}渠道的包名与当前渠道一致，因此会一并修改上述渠道对应登录方式的参数。` : ''}
                                ${productCnames ? `同时我们检测到${productCnames}渠道的productId与当前渠道${productId.value}一致，因此会一并修改上述渠道对应登录方式的参数。` : ''}`, '提示', {
            customStyle: {
              width: '650px'
            },
            confirmButtonText: '取消，不保存',
            cancelButtonText: '确认保存',
            dangerouslyUseHTMLString: true,
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            // to do
          }).catch(action => {
            if (action === 'cancel') {
              confirmLoading.value = true;
              return apiUsdkSaveInternalLoginSwitchConf({
                gid: props.gid,
                cids: props.channel.cid,
                ...params
              }).then(res => {
                if (res.code === 0) {
                  emits('ok');
                  // handleClose();
                }
              }).finally(() => {
                confirmLoading.value = false;
              });
            }
          });
        }
      });
    };
    const currentLogin = ref({});
    const handleClick = params => {
      currentLogin.value = params;
    };
    const handleToLink = () => {
      window.open('https://herogames.feishu.cn/wiki/Rwv2wM8koi4TGWkt47QcMYI5nKd#part-B1M5doWuCoTU1lxNTI0ctkcnnif', '_blank');
    };
    const currentProvider = ref('1');
    const providerOptions = ref([{
      label: '创蓝云智',
      value: '1'
    }]);
    // 解析.p8文件获取appSecret
    const onChangeAppSecret = (item, p) => {
      let $input = document.getElementById('input-file');
      $input.onchange = e => {
        let file = e.target.files[0] || null;
        if (!file) return;
        let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
        console.log(fileExtension);
        if (fileExtension !== 'p8') {
          ElMessage('请上传.p8结尾的文件');
          return;
        }
        let reader = new FileReader();
        reader.readAsText(file, 'UTF-8');
        reader.onload = evt => {
          let fileString = evt.target.result;
          if (!fileString.includes('-----BEGIN PRIVATE KEY-----')) {
            ElMessage('文件格式不对，请重新上传');
            return;
          }
          fileString = fileString.replace('-----BEGIN PRIVATE KEY-----', '');
          fileString = fileString.replace('-----END PRIVATE KEY-----', '');
          fileString = fileString.replace(/\r\n/g, '');
          fileString = fileString.replace(/\n/g, '');
          proParams.value[item.type + 'Conf'][p.key] = fileString;
          ElMessage.success('解析成功！');
          showInputFile.value = false;
          setTimeout(() => {
            showInputFile.value = true;
          }, 200);
        };
      };
      $input.click();
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_checkbox = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_i_ep_Document = __unplugin_components_4;
      const _component_el_icon = __unplugin_components_5;
      const _component_i_ep_Upload = __unplugin_components_6;
      const _component_el_input = __unplugin_components_7;
      const _component_el_form_item = __unplugin_components_8;
      const _component_el_empty = __unplugin_components_9;
      const _component_el_form = __unplugin_components_10;
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
        to: "#internalLogin"
      }, [_createVNode(_component_el_button, {
        loading: _unref(confirmLoading),
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("保存")]),
        _: 1
      }, 8, ["loading"])])), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(internalLogin), item => {
        return _openBlock(), _createElementBlock(_Fragment, null, [(__props.channel.channel !== _unref($channel).OFFICIAL_IOS_CHANNEL ? item.type !== 'apple' : item.type) ? (_openBlock(), _createElementBlock("div", {
          key: item.type,
          class: _normalizeClass(['check-item', item.type === _unref(currentLogin).type ? 'active-check-item' : '']),
          onClick: $event => handleClick(item)
        }, [_createVNode(_component_el_checkbox, {
          modelValue: _unref(proParams)[item.type],
          "onUpdate:modelValue": $event => _unref(proParams)[item.type] = $event,
          "false-label": 0,
          "true-label": 1,
          class: "marginR5"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("img", {
          src: _unref(loginIcon)[item.type],
          alt: "",
          style: {
            "margin-right": "3px"
          },
          width: "16"
        }, null, 8, _hoisted_6), _createTextVNode(_toDisplayString(item.label), 1)], 10, _hoisted_5)) : _createCommentVNode("", true)], 64);
      }), 256))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _unref(currentLogin).type === 'phoneQK' ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "flex items-center marginL20 cp",
        style: {
          "color": "#edc587"
        },
        onClick: handleToLink
      }, [_createTextVNode(" 使用说明 "), _createElementVNode("img", {
        src: _unref(questionIcon),
        alt: "",
        style: {
          "width": "16px"
        }
      }, null, 8, _hoisted_11)])) : _createCommentVNode("", true)]), _unref(currentLogin).type === 'phoneQK' ? (_openBlock(), _createBlock(_component_el_select, {
        key: 0,
        modelValue: _unref(currentProvider),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentProvider) ? currentProvider.value = $event : null),
        placeholder: "请选择",
        size: "small"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(providerOptions), item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_unref(currentLogin).operateDesc ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createTextVNode("请按 "), _createElementVNode("a", {
        href: _unref(currentLogin).operateDesc,
        target: "_blank"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_i_ep_Document)]),
        _: 1
      }), _createTextVNode(" 操作说明")], 8, _hoisted_14), _createTextVNode("提交审核并获取参数 ")])) : _createCommentVNode("", true), _createVNode(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: _unref(proParams),
        "label-width": "150px",
        labelAlign: "left"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(internalLogin), item => {
          return _openBlock(), _createElementBlock(_Fragment, null, [(__props.channel.channel !== _unref($channel).OFFICIAL_IOS_CHANNEL ? item.type !== 'apple' : item.type) ? (_openBlock(), _createElementBlock("div", {
            key: item.type
          }, [item.params && _unref(currentLogin) && _unref(currentLogin).type === item.type ? (_openBlock(), _createElementBlock("div", {
            key: item.type + 1,
            class: "params-box"
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.params, p => {
            return _openBlock(), _createElementBlock(_Fragment, null, [!p.ios || __props.channel.channel === _unref($channel).OFFICIAL_IOS_CHANNEL ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: p.key,
              label: p.label,
              prop: [item.type + 'Conf'] + '.' + [p.key],
              rules: {
                required: true,
                message: `请填写${p.label}`,
                trigger: 'change'
              },
              "wrapper-col": {
                span: 14
              }
            }, {
              default: _withCtx(() => [item.type === 'apple' && p.key === 'appSecret' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_button, {
                class: "upload-btn",
                plain: "",
                type: "primary",
                onClick: $event => onChangeAppSecret(item, p)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_i_ep_Upload)]),
                  _: 1
                }), _createTextVNode(" " + _toDisplayString(_unref(proParams)[item.type + 'Conf'][p.key] ? '重新上传' : '点击上传'), 1)]),
                _: 2
              }, 1032, ["onClick"]), _hoisted_17]), _createVNode(_component_el_input, {
                modelValue: _unref(proParams)[item.type + 'Conf'][p.key],
                "onUpdate:modelValue": $event => _unref(proParams)[item.type + 'Conf'][p.key] = $event,
                disabled: "",
                placeholder: "上传P8文件后自动生成"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])], 64)) : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: _unref(proParams)[item.type + 'Conf'][p.key],
                "onUpdate:modelValue": $event => _unref(proParams)[item.type + 'Conf'][p.key] = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true)], 64);
          }), 256))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
        }), 256)), !_unref(currentLogin).type || !_unref(currentLogin).params ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "不需要配置参数"
        })) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["model"])])])]), _unref(showInputFile) ? (_openBlock(), _createElementBlock("input", _hoisted_18)) : _createCommentVNode("", true)], 64);
    };
  }
});